export default{
    namespaced: true,

    state:{
        fecha:null,
        timeoutCirugias:null,

        ciruSeguraItems:{
            pre:{
                paciente:[
                    {id:101, label:"Si identidad", model:"identidad"},
                    {id:102,label:"El sitio quirúrgico", model:"sitio"},
                    {id:103,label:"El procedimiento quirúrgico", model:"proc"},
                    {id:104,label:"Diagnóstico de presunción", model:"diag"},
                    {id:105,label:"Su consentimiento", model:"consentimiento"},
                    {id:106,label:"Marcaje del sitio quirúrgico", model:"marcaje"},
                ],
                medico:[
                    {id:107,label:"Máquina de anestesia", model:"anestesia"},
                    {id:108,label:"Monitor de signos vitales", model:"monitor"},
                    {id:109,label:"Mesa quirúrgica", model:"mesa"},
                    {id:110,label:"Lámpara quirúrgica", model:"lampara"},
                    {id:111,label:"Aspirador", model:"aspirador"},
                    {id:112,label:"Unidad de electrocirugía", model:"electrociru"},
                ],
                varios:[
                    {id:113, label:"¿Tiene el paciente alergias conocidas?", model:"alergias"},
                    {id:114, label:"¿Vía aérea difícil/riesgo de aspiración?", model:"aerea", respuestaSi:"Sí y se ha previsto la disponibilidad de líquidos y dos vías centrales"},
                    {id:115, label:"Riesgo de hemorragia en Adultos >500ml Niños >7ml/kg?", model:"hemorragia"},
                    {id:116, label:"¿Hemoderivados?", model:"hemoderivados"},
                    {id:117, label:"¿Soluciones disponibles?", model:"soluciones"},
                    {id:118, label:"¿Cuenta con acceso venoso adecuado?", model:"accesoVenoso"},
                    {id:119, label:"Requiere de Rx trans-operatorios", model:"rx", respuestaSi:"El equipo está dentro del quirófano"},
                ],

            },
            trans:{
                equipo:[
                    {id:201,label:"Cirujano", model:"cirujano"},
                    {id:202,label:"Anestesiólogo", model:"anestesio"},
                    {id:203,label:"Instrumentista", model:"instru"},
                    {id:204,label:"Ayudante", model:"ayuda"},
                    {id:205,label:"Circulante", model:"circula"},
                    {id:206,label:"Biomédico", model:"biomedico"},
                ],
                actividades:[
                    {id:207,label:"¿Se realizó la asepsia en un sitio quirúrgico?", model:"asepsia"},
                    {id:208,label:"El cirujano revisa: los pasos críticos o imprevistos, la duración de la operación y la pérdida de sangre prevista.", model:"cirujano"},
                    {id:209,label:"El anestesiólogo notifica: si el paciente presenta algún riesgo o enfermedad que complique la cirugía.", model:"anestesio"},
                    {id:210,label:"El equipo de enfermería revisa: si se ha confirmado la esterilidad (con resultados de los indicadores) y si existen dudas o problemas relacionados con el instrumental y los equipos y el conteo de los mismos.", model:"enfermeria"},
                    {id:211,label:"¿Se ha administrado profilaxis antibiótica en los últimos 60 minutos?", model:"profilaxis"},
                    {id:212,label:"¿Pueden visualizarse las imágenes diagnósticas?", model:"imagenes", respuestaNo:"No procede"},
                ],
                pausa:[
                    {id:213,label:"Posición correcta del paciente", model:"posicion"},
                    {id:214,label:"La identidad del paciente", model:"identidad"},
                    {id:215,label:"El sitio quirúrgico", model:"sitio"},
                    {id:216,label:"El procedimiento", model:"proc"},
                    {id:217,label:"¿En caso de órgano bilateral, ha marcado derecho o izquierdo, según corresponda?", model:"organo"},
                    {id:218,label:"En caso de estructura múltiple se ha especificado el nivel a operar", model:"estructura"},
                ],
            },
            post:{
                confirma:[
                    {id:301,label:"El nombre del procedimiento realizado", model:"proc"},
                    {id:302,label:"¿Los recuentos de gasas, compresas y agujas e instrumentos son correctos?", model:"gasas"},
                    {id:303,label:"El etiquetado de las muestras (cuenta con los datos establecidos).", model:"muestras"},
                    {id:304,label:"Si hay problemas que resolver relacionados con el instrumental y los equipos", model:"instrumental"},
                ],
                revisa:[
                    {id:305,label:"Los principales aspectos de la recuperación posoperatoria del paciente.", model:"recu"},
                    {id:306,label:"El plan de tratamiento", model:"tratamiento"},
                    {id:307,label:"Los riesgos", model:"riesgos"},

                ],
            },
        }
    },
    mutations:{
        CAMBIA_FECHA(state, data){
            //console.log(data.root)
            state.fecha = data
        },
        SET_TIMEOUT(state, data){
            //console.log(data.root)
            state.timeoutCirugias = data
        },
        CLEAR_TIMEOUT(state){
            clearTimeout(state.timeoutCirugias)
        }
        


    },
    actions:{
        //
    },
    getters:{
        //
    },
}